import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-hairline bg-deep"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-10 grid grid-cols-1 md:grid-cols-3 items-center gap-8">
        <div className="flex justify-start">
          <Logo
            size="lg"
            className="!items-center [&>span:first-child]:!text-[30px] [&>span:last-child]:!mt-0.5 [&>span:last-child]:!text-[13px] [&>span:last-child]:!font-medium [&>span:last-child]:!tracking-[0.32em] [&>span:last-child]:!text-gold"
          />
        </div>
        <nav className="flex flex-wrap items-center justify-start md:justify-center gap-8 text-[13px] text-offwhite/70">
          <Link
            to="/"
            data-testid="footer-link-home"
            className="hover:text-gold transition-colors"
          >
            Home
          </Link>
          <Link
            to="/services"
            data-testid="footer-link-services"
            className="hover:text-gold transition-colors"
          >
            Services
          </Link>
          <Link
            to="/about"
            data-testid="footer-link-about"
            className="hover:text-gold transition-colors"
          >
            About
          </Link>
          <Link
            to="/contact"
            data-testid="footer-link-contact"
            className="hover:text-gold transition-colors"
          >
            Contact
          </Link>
        </nav>
        <p className="text-[12px] tracking-wide text-[#5F5C55] md:text-right">
          © {new Date().getFullYear()} Sable Advisory. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
